// Generated by CoffeeScript 2.7.0
var delegate_property_func,
  splice = [].splice;

Object.defineProperty(Object.prototype, 'dig', {
  enumerable: false,
  configurable: false,
  writable: false,
  value: function() {
    var val;
    val = _.clone(this);
    _.every(_.flatten([arguments]), function(key) {
      return val = _.has(val, key) ? val[key] : void 0;
    });
    return val;
  }
});

delegate_property_func = function(obj, property_name, target) {
  return Object.defineProperty(obj, property_name, {
    enumerable: false,
    configurable: false,
    get: function() {
      var method;
      method = target[property_name];
      if (method instanceof Function) {
        return method.bind(target);
      } else {
        return method;
      }
    }
  });
};

Object.defineProperty(Object.prototype, 'delegateTo', {
  enumerable: false,
  configurable: false,
  writable: false,
  value: function(...method_names) {
    var ref, target;
    ref = method_names, [...method_names] = ref, [target] = splice.call(method_names, -1);
    _.chain(method_names).flatten().each((method_name) => {
      return delegate_property_func(this, method_name, target);
    });
    return this;
  }
});

// 为所有类添加组合方法，扩展该类的实例方法或属性
Object.defineProperty(Function.prototype, 'assemble', {
  enumerable: false,
  configurable: false,
  writable: false,
  value: function(target) {
    var key, value;
    for (key in target) {
      value = target[key];
      if (!this.hasOwnProperty(key)) {
        this.prototype[key] = value;
      }
    }
    return this;
  }
});
